export default id => {switch (id) {
    case 1: return "CHOICE";
    case 2: return "ASSOCIATION";
    case 3: return "STRING";
    case 4: return "INTEGER";
    case 5: return "DECIMAL";
    case 7: return "TZTIMESTAMP";
    case 8: return "INTERVAL";
    case 9: return "TIME";
    case 10: return "DATE";
    case 11: return "DATETIME";
    case 12: return "FILE";
    default: throw new Error("Unrecognized type id: " + id);
}};



// WEBPACK FOOTER //
// ./app/jsmodel/get_type_key.js